/* ==========================================================================
   Custom Mega Menu — Phase 2a: controller for server-rendered panels.
   - Isolated IIFE, no globals.
   - Opened by the existing header trigger: .custom-mega-trigger
   - All hooks are data attributes (data-custom-mega-*).
   - Panels are server-rendered by the custom-mega-* snippets (static
     fallback content for now); this script only handles state:
     open/close, root <-> category switching, promo column, accordions.
   Behaviors are identical to the approved prototype.
   ========================================================================== */
(function () {
  'use strict';

  /* Latest bound instance — used by the document-level listeners below so
     they survive theme editor section re-renders (shopify:section:load). */
  var api = {
    isOpen: function () {
      return false;
    },
    close: function () {},
  };

  function init() {
  var root = document.querySelector('[data-custom-mega]');
  if (!root) return;

  /* The theme editor can re-render the section while the menu is open —
     make sure a stale body scroll lock never sticks around. */
  document.body.style.overflow = '';
  document.documentElement.classList.remove('mega-menu-open');
  document.body.classList.remove('mega-menu-open');
  document.documentElement.style.removeProperty('--mega-menu-sbw');

  /* ===== DOM ===== */
  var overlay = root.querySelector('[data-custom-mega-overlay]');
  var panel = root.querySelector('[data-custom-mega-panel]');
  var content = root.querySelector('[data-custom-mega-content]');
  var promos = root.querySelector('[data-custom-mega-promos]');
  var backBtn = root.querySelector('[data-custom-mega-back]');
  var backLabel = root.querySelector('[data-custom-mega-back-label]');
  var triggers = document.querySelectorAll('.custom-mega-trigger');
  if (!overlay || !panel || !content || !promos || !backBtn || !backLabel) return;

  var OPEN_CLASS = 'custom-mega-overlay--open';
  var WIDE_CLASS = 'custom-mega-panel--wide';
  var ACC_OPEN_CLASS = 'custom-mega-accordion--open';

  var views = content.querySelectorAll('[data-custom-mega-view]');
  var rootView = content.querySelector('[data-custom-mega-view="root"]');
  var promoCards = promos.querySelectorAll('[data-custom-mega-promo-group]');

  /* ===== State ===== */
  var prevBodyOverflow = '';
  /* The desktop hover trigger — the "Shop" nav link — is resolved in Events. */
  var shopTrigger = null;

  /* ===== Helpers ===== */
  function isOpen() {
    return overlay.classList.contains(OPEN_CLASS);
  }

  function setExpanded(value) {
    triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', value ? 'true' : 'false');
    });
    if (shopTrigger) {
      shopTrigger.setAttribute('aria-expanded', value ? 'true' : 'false');
    }
  }

  /* ===== Signature sliders (scrollbar-less row with arrow controls) ===== */
  var signatureUpdaters = [];

  function bindSignatureSliders() {
  root.querySelectorAll('[data-custom-mega-signature-slider]').forEach(function (slider) {
    var scroller = slider.querySelector('.custom-mega-signature-scroll');
    var prev = slider.querySelector('[data-custom-mega-signature-prev]');
    var next = slider.querySelector('[data-custom-mega-signature-next]');
    if (!scroller || !prev || !next) return;

    function step() {
      return Math.max(scroller.clientWidth * 0.8, 100);
    }

    function update() {
      var overflow = scroller.scrollWidth - scroller.clientWidth > 1;
      prev.hidden = !overflow;
      next.hidden = !overflow;
      if (!overflow) return;
      var max = scroller.scrollWidth - scroller.clientWidth;
      prev.disabled = scroller.scrollLeft <= 1;
      next.disabled = scroller.scrollLeft >= max - 1;
    }

    prev.addEventListener('click', function () {
      scroller.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      scroller.scrollBy({ left: step(), behavior: 'smooth' });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // --- UPDATED DESKTOP MOUSE DRAG FOR LINKS ---
    var isDown = false;
    var startX;
    var scrollLeft;
    var dragMoved = false;

    scroller.addEventListener('mousedown', function (e) {
      isDown = true;
      dragMoved = false;
      scroller.classList.add('is-dragging');
      startX = e.pageX - scroller.offsetLeft;
      scrollLeft = scroller.scrollLeft;
    });

    scroller.addEventListener('mouseleave', function () {
      isDown = false;
      scroller.classList.remove('is-dragging');
    });

    scroller.addEventListener('mouseup', function () {
      isDown = false;
      // Slight delay to prevent immediate click trigger on mouseup
      setTimeout(function() {
        scroller.classList.remove('is-dragging');
      }, 50);
    });

    scroller.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - scroller.offsetLeft;
      var walk = (x - startX) * 1.5; 
      
      // If the user moves more than 5px, count it as a drag movement
      if (Math.abs(x - startX) > 5) {
        dragMoved = true;
      }
      
      if (dragMoved) {
        e.preventDefault();
        scroller.scrollLeft = scrollLeft - walk;
      }
    });

    // Intercept clicks on the link items inside the scroller
    scroller.querySelectorAll('.custom-mega-signature-item').forEach(function(link) {
      link.addEventListener('click', function(e) {
        if (dragMoved) {
          e.preventDefault(); // Blocks the link navigation if we were dragging
        }
      });
    });
    // --------------------------------------------

    signatureUpdaters.push(update);
    update();
  });
}

  function updateSignatureSliders() {
    signatureUpdaters.forEach(function (update) {
      update();
    });
  }

  /* ===== Start Here product slider (Swiper, vendored by the theme) ===== */
  var startSwipers = [];

  function bindStartSliders() {
    root.querySelectorAll('[data-custom-mega-start-slider]').forEach(function (slider) {
      var swiperEl = slider.querySelector('[data-custom-mega-start-swiper]');
      var dotsEl = slider.querySelector('[data-custom-mega-start-dots]');
      var slides = slider.querySelectorAll('[data-custom-mega-start-slide]');
      if (!swiperEl || slides.length < 2) return;

      if (typeof window.Swiper === 'function') {
        var options = {
          /* Vertical sliding so products change up/down, matching the vertical
             dots. Touch-drag disabled so a vertical swipe scrolls the panel
             instead of being captured by the slider; autoplay + clickable dots
             still drive it. */
          direction: 'vertical',
          allowTouchMove: false,
          slidesPerView: 1,
          spaceBetween: 16,
          loop: true,
          observer: true,
          observeParents: true,
          /* Auto-advance every 3s, loop back via loop:true above. Pause on
             hover; keep running after dot-click/swipe (disableOnInteraction:
             false). Only reached when slides.length >= 2 (guarded above), so
             a single-slide slider never autoplays. */
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
        };
        if (dotsEl) {
          options.pagination = {
            el: dotsEl,
            clickable: true,
            bulletClass: 'custom-mega-start-dot',
            bulletActiveClass: 'custom-mega-start-dot--active',
          };
        }
        startSwipers.push(new window.Swiper(swiperEl, options));
      } else {
        /* Swiper unavailable — degrade to a static first card */
        slides.forEach(function (slide, i) {
          slide.hidden = i !== 0;
        });
        if (dotsEl) dotsEl.hidden = true;
      }
    });
  }

  function updateStartSwipers() {
    startSwipers.forEach(function (swiper) {
      if (swiper && typeof swiper.update === 'function') swiper.update();
    });
  }

  /* ===== Views ===== */
  function showView(el) {
    views.forEach(function (v) {
      v.hidden = v !== el;
    });
    el.scrollTop = 0;
    /* Panels are measurable only once visible — re-evaluate slider overflow */
    updateSignatureSliders();
  }

  function showRoot() {
    backBtn.hidden = true;
    panel.classList.remove(WIDE_CLASS);
    promoCards.forEach(function (c) {
      c.hidden = true;
    });
    if (rootView) showView(rootView);
  }

  function showCategory(id) {
    var target = content.querySelector('[data-custom-mega-category="' + id + '"]');
    if (!target) return;
    backBtn.hidden = false;
    backLabel.textContent = target.getAttribute('data-custom-mega-label') || 'Back';
    panel.classList.toggle(WIDE_CLASS, target.hasAttribute('data-custom-mega-has-promos'));
    var visibleCount = 0;
    promoCards.forEach(function (c) {
      c.hidden = c.getAttribute('data-custom-mega-promo-group') !== id;
      if (!c.hidden) visibleCount++;
    });
    /* 1-2 banners: vertical stack. 3-4 banners: 2-column grid (2 per row). */
    promos.classList.toggle('custom-mega-promos--grid', visibleCount > 2);
    showView(target);
  }

  /* ===== Open / close ===== */
  function openMenu() {
    if (isOpen()) return;
    overlay.classList.add(OPEN_CLASS);
    overlay.setAttribute('aria-hidden', 'false');
    setExpanded(true);
    prevBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    /* Desktop background scroll lock. The CSS for this class is gated to
       >= 1025px, so it is inert on mobile (the inline lock above keeps governing
       the mobile menu). html carries the class too because it is the actual
       scroll container (critical.css: html { overflow-x: hidden }). */
    /* Measure the scrollbar width while it is still visible, then expose it so
       the CSS lock can reserve that space — this prevents the page behind from
       shifting sideways when the scrollbar disappears on open. */
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty('--mega-menu-sbw', scrollbarWidth + 'px');
    }
    document.documentElement.classList.add('mega-menu-open');
    document.body.classList.add('mega-menu-open');
    showRoot();
    updateStartSwipers();
  }

  function closeMenu() {
    if (!isOpen()) return;
    overlay.classList.remove(OPEN_CLASS);
    overlay.setAttribute('aria-hidden', 'true');
    setExpanded(false);
    document.body.style.overflow = prevBodyOverflow;
    document.documentElement.classList.remove('mega-menu-open');
    document.body.classList.remove('mega-menu-open');
    document.documentElement.style.removeProperty('--mega-menu-sbw');
    setTimeout(function () {
      showRoot();
    }, 300);
  }

  /* ===== Accordions (single-open, +/- icon) ===== */
  function bindAccordions() {
    content.querySelectorAll('.custom-mega-accordion').forEach(function (acc) {
      var head = acc.querySelector('.custom-mega-accordion-head');
      if (!head) return;
      head.addEventListener('click', function () {
        var willOpen = !acc.classList.contains(ACC_OPEN_CLASS);
        content.querySelectorAll('.custom-mega-accordion').forEach(function (other) {
          other.classList.remove(ACC_OPEN_CLASS);
        });
        if (willOpen) {
          acc.classList.add(ACC_OPEN_CLASS);
        }
      });
    });
  }

  /* ===== Events ===== */
  /* Click-to-open is bound to the MOBILE trigger ONLY. The mobile menu depends
     on this and is left exactly as-is. The desktop hamburger is intentionally
     NOT bound to anything here: on desktop the mega menu opens from the SHOP
     nav item (hover, below) and the hamburger is hidden via CSS, so it has no
     mega menu behavior at all. */
  triggers.forEach(function (t) {
    if (!t.classList.contains('custom-mega-trigger--mobile')) return;
    t.addEventListener('click', function (e) {
      e.preventDefault();
      openMenu();
    });
  });

  /* ===== Desktop-only hover trigger: the SHOP nav item (>= 1025px) =====
     On desktop the mega menu opens when the pointer enters the "Shop" item in
     the main navigation, and closes once the pointer leaves both that item and
     the panel. A short delay bridges the gap the cursor travels between the nav
     item and the slide-in panel so the menu does not flicker shut in between.

     Mobile is untouched: every handler here is gated behind the desktop media
     query, so touch/mobile never opens or closes the mega menu via hover, and
     tapping "Shop" on mobile just follows its link as before. */
  var desktopMq = window.matchMedia('(min-width: 1025px)');
  var hoverCloseTimer = null;

  function cancelHoverClose() {
    if (hoverCloseTimer) {
      clearTimeout(hoverCloseTimer);
      hoverCloseTimer = null;
    }
  }

  function scheduleHoverClose() {
    cancelHoverClose();
    hoverCloseTimer = setTimeout(closeMenu, 200);
  }

  /* Resolve the "Shop" navigation link (a plain link with no native dropdown).
     Matched by its visible label, scoped to the main nav so links inside the
     mega menu overlay are never picked up. First match in DOM order wins. */
  Array.prototype.some.call(
    document.querySelectorAll('.navigation a, .horizontal-list a'),
    function (a) {
      if ((a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() !== 'shop') {
        return false;
      }
      shopTrigger = a;
      return true;
    }
  );

  // if (shopTrigger) {
  //   shopTrigger.addEventListener('mouseenter', function () {
  //     if (!desktopMq.matches) return;
  //     cancelHoverClose();
  //     openMenu();
  //   });
  //   shopTrigger.addEventListener('mouseleave', function () {
  //     if (!desktopMq.matches) return;
  //     scheduleHoverClose();
  //   });
  // }

  if (shopTrigger) {

  shopTrigger.addEventListener('click', function (e) {
    if (!desktopMq.matches) return;

    e.preventDefault();
    e.stopPropagation();

    if (isOpen()) {
      closeMenu();
    } else {
      openMenu();
    }
  });

}


  /* Keep the menu open while the pointer is over the panel; close shortly
     after it leaves (onto the backdrop or off-screen). */
  // panel.addEventListener('mouseenter', function () {
  //   if (!desktopMq.matches) return;
  //   cancelHoverClose();
  // });
  // panel.addEventListener('mouseleave', function () {
  //   if (!desktopMq.matches) return;
  //   scheduleHoverClose();
  // });

  content.querySelectorAll('.custom-mega-explore-list button[data-id]').forEach(function (b) {
    b.addEventListener('click', function () {
      showCategory(b.dataset.id);
    });
  });

  bindAccordions();
  bindSignatureSliders();
  bindStartSliders();

  backBtn.addEventListener('click', showRoot);

  root.querySelectorAll('[data-custom-mega-close]').forEach(function (el) {
    el.addEventListener('click', closeMenu);
  });

  api.isOpen = isOpen;
  api.close = closeMenu;
  }

  init();

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && api.isOpen()) api.close();
  });

  /* Theme editor: section DOM is replaced on setting/block changes — rebind. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-custom-mega]')) init();
  });
})();
